import { ddayjs } from '@dt/fe-utils'
import { each } from '@dt/fe-utils/dist/lodash'

// 时间转换
export const m2n = (m: string) => parseInt(m.split(':').join(''))
export const d2n = (m: string) => parseInt(m.split('-').join(''))
// 检查时间
export const checkTime = (startTime: string, endTime: string, checkTime: string) => {
  const startVal: number = m2n(startTime)
  const endVal: number = m2n(endTime)
  const checkVal: number = m2n(checkTime)
  if (checkVal < startVal || checkVal > endVal) {
    return false
  }
  return true
}
// 检测活动有效时间段
export const checkActiveTime = (timeRange: any[]) => {
  const week: number = ddayjs().day()
  const time: string = ddayjs().format('HH:mm')
  let checkRes: boolean = true
  each(timeRange, (item: any) => {
    if (item.weekDay === week) {
      if (item.isOpen) {
        each(item.ranges, (rItem: any) => {
          if (!checkTime(rItem.startTime, rItem.endTime, time)) {
            checkRes = false
          }
        })
      } else {
        checkRes = false
      }
    }
  })
  return checkRes
}

export const checkActiveNoStart = (time: string) => {
  const dateArr: any[] = time.split(' ')
  const currentDate: any = ddayjs().format('YYYY-MM-DD')
  const currentTime: any = ddayjs().format('HH:mm:ss')
  if (d2n(currentDate) < d2n(dateArr[0])) {
    return true
  }
  if (m2n(currentTime) < m2n(dateArr[1])) {
    return true
  }
  return false
}

export const checkActiveHasEnd = (time: string) => {
  const dateArr: any[] = time.split(' ')
  const currentDate: any = ddayjs().format('YYYY-MM-DD')
  const currentTime: any = ddayjs().format('HH:mm:ss')
  if (d2n(currentDate) > d2n(dateArr[0])) {
    return true
  }
  if (m2n(currentTime) > m2n(dateArr[1])) {
    return true
  }
  return false
}

export const checkExpire = (expireTime: string, currentTime: string) => {
  const expireArr: any[] = expireTime.split(' ')
  const currentArr: any[] = currentTime.split(' ')
  if (d2n(expireArr[0]) < d2n(currentArr[0])) {
    return true
  }
  if (d2n(expireArr[0]) === d2n(currentArr[0]) && m2n(expireArr[1]) < m2n(currentArr[1])) {
    return true
  }
  return false
}

export const getChannel = (data: any[]) => {
  const channelRes: any[] = []
  const eatRes: any[] = []
  each(data, (item: any) => {
    const arr: any[] = item.split(/(?=[A-Z])/)
    if (arr[0] === 'delivery') {
      if (!channelRes.includes('delivery')) {
        channelRes.push('delivery')
      }
    } else {
      if (!eatRes.includes(arr[0])) {
        eatRes.push(arr[0])
      }
      if (!channelRes.includes(arr[1])) {
        channelRes.push(arr[1])
      }
    }
  })
  const resultRes: any = {
    channel: channelRes,
    eatType: eatRes
  }
  return resultRes
}

export const filterNickname = (name: string) => {
  const reg: RegExp = /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g
  const str: string = name.replace(reg, '')
  return str
}

/**
 * 计算两个日期之间的天数
 * @param dateString1  开始日期 yyyy-MM-dd
 * @param dateString2  结束日期 yyyy-MM-dd
 * @returns {number} 如果日期相同 返回一天 开始日期大于结束日期，返回0
 */
export const getDaysBetween = (dateString1: string, dateString2: string) => {
  const startDate = Date.parse(dateString1)
  const endDate = Date.parse(dateString2)
  if (startDate > endDate) {
    return 0
  }
  if (startDate === endDate) {
    return 1
  }
  const days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000)
  return days
}

/** 复制到剪切板 */
export const copyText = (text: string) => {
  let copyArea = document.querySelector('#copyArea') as any
  if (!copyArea) {
    copyArea = document.createElement('textArea')
    copyArea.setAttribute('class', 'hidden-copy-area')
    copyArea.setAttribute('readonly', '')
    copyArea.innerText = text
    document.body.appendChild(copyArea)
    copyArea.select()
    document.execCommand('copy')
    window.getSelection().empty()
  }
}

/** 优惠券总数/id列表 */
export const getCouponsInfo = (list: any, type?: 'cnt' | 'id', map?: any) => {
  let cnt: number = 0
  let ids: any = []
  each(list, (item: any) => {
    if (type === 'cnt') {
      if (!map || map[item.couponId]) cnt += item.couponCnt
    } else {
      if (!ids.includes(item.couponId) && (!map || map[item.couponId]) && item.couponId) ids.push(item.couponId)
    }
  })
  return type === 'cnt' ? cnt : ids
}

// 获取过期天数
export const getExpireDay = (expireTime: any) => {
  const interVal: number = ddayjs(expireTime, 'brand').valueOf() - ddayjs('brand').valueOf()
  return Math.ceil(interVal / (1000 * 60 * 60 * 24))
}

export const getPercent = (pernum: number, total: number) => {
  if (pernum && total) {
    return Number(((pernum / total) * 100).toFixed(2))
  } else {
    return 0
  }
}

// 获取会员卡状态
export const getMemberCardStatus = (cardInfo: any, expireTipDay?: number) => {
  const info: any = {
    status: 1,
    icon: '',
    expireDay: 0,
    expireTime: null,
    isToday: false
  }
  let day: number = 0
  if (cardInfo.expireTime) {
    day = getExpireDay(cardInfo.expireTime)
  }
  if (cardInfo.status === 'disable') {
    info.status = 2
    info.icon = 'icon-suo'
  } else if (cardInfo.expireTime && expireTipDay && day > 0 && day <= expireTipDay) {
    info.status = 4
    info.expireDay = day
    info.expireTime = cardInfo.expireTime
    if (ddayjs(cardInfo.expireTime, 'brand').valueOf() < ddayjs('brand').endOf('day').valueOf()) {
      info.isToday = true
    }
  } else if (cardInfo.expireTime && day <= 0) {
    info.status = 3
    info.icon = 'icon-yiguoqi-yiyuqi-04'
  }
  return info
}

export const defaultPhyCover = 'https://eshine-image-test.oss-cn-hangzhou.aliyuncs.com/giftcardCover/2304998902ba46bfb45f361ea5638e0d.jpg'
